// extracted by mini-css-extract-plugin
export default {"wrapper":"ExpandableDescription_wrapper__oxD4F","clamp":"ExpandableDescription_clamp__3Js2i","hoverTip":"ExpandableDescription_hoverTip__0H-+L"};